import React from 'react';
import './CourseKind.css';

const NAME = { standard: 'Standard', mastery: 'Mastery' };

/* Class cards (admin + teacher Classes): "Mastery 8/8 · Standard 12/16" and the sessions not scheduled yet.
   stats = { ready, classType, types: { standard: { taken, bought, left }, mastery: {...} } } from the API.
   Returns null when there's nothing to show (the page then shows the old "Class 7/8"). */
const SessionTypeTags = ({ stats, currentLabel = 'this class', typeOnly = false }) => {
  if (!stats?.ready || !stats.types) return null;
  // teachers: "Standard 5/8" (where the student is in the package), never anything about payment:
  // past the package ("10/8" would show it isn't paid yet) it shows only "Standard · session 10"
  if (typeOnly) {
    const t = stats.classType === 'mastery' ? 'mastery' : 'standard';
    const x = stats.types[t] || {};
    const taken = Number(x.taken) || 0;
    const bought = Number(x.bought) || 0;
    return (
      <span className={`rmck-count is-${t} is-current`} title={`${NAME[t]} sessions`}>
        <b>{bought > 0 && taken <= bought ? `${NAME[t]} ${taken}/${bought}` : taken > 0 ? `${NAME[t]} · session ${taken}` : `${NAME[t]} sessions`}</b>
      </span>
    );
  }
  const order = [stats.classType, stats.classType === 'mastery' ? 'standard' : 'mastery'];
  const shown = order.filter((t, i) => i === 0 || stats.types[t].bought > 0 || stats.types[t].taken > 0);
  return (
    <>
      {shown.map((t) => {
        const x = stats.types[t];
        const current = t === stats.classType;
        return (
          <span
            key={t}
            className={`rmck-count is-${t} ${current ? 'is-current' : ''} ${x.left < 0 ? 'is-over' : ''}`}
            title={`${NAME[t]}: ${x.taken} of ${x.bought} paid sessions${current ? ` (${currentLabel})` : ''} · ${x.left} not scheduled yet`}
          >
            <b>
              {NAME[t]} {x.taken}/{x.bought}
            </b>
            {x.left > 0 && <span>· {x.left} to schedule</span>}
            {x.left < 0 && <span>· {-x.left} not paid</span>}
          </span>
        );
      })}
    </>
  );
};

export default SessionTypeTags;
